import React from "react"
import Back from "../../common/Back"
import img from "../../images/about.jpeg"
import "../hero/hero.css"

const Hero = () => {
  return (
    <>
      <section className='hero'>
        <Back name="Let us take care of the details, so you can focus on making memories!" title='Meta Decor & Catering' cover={img} />
      </section>
    </>
  )
}

export default Hero
